import { Box, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LinkStyled = styled(Link)({
  marginLeft: '5px',
  marginTop: '1px',
  fontSize: '18px',
  color: 'black',
  fontWeight: 'bold',
  textDecorationColor: 'black',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const PhoneIconImg = styled('img')({
  height: '35px',
  marginRight: '20px',
  marginLeft: '10px',
});

export const LockIconImg = styled('img')({
  height: '35px',
  marginRight: '20px',
});

export const ErrorMessageBox = styled(Box)(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: '10px',
  marginBottom: '10px',
  width: '100%',
}));
